import type { Theme } from '@mui/material';

export const styles = {
  reportTable: {
    minHeight: '3.125rem',
    width: '100%',
    overflow: 'auto',
    position: 'relative',
    pb: 2,
  },

  panel: (theme: Theme) => ({
    margin: 'auto',
    textAlign: 'center',
    minWidth: '20rem',
    border: `1px solid ${theme.colors.neutral[200]}`,
    borderRadius: '0.5rem',
    padding: '2rem',
  }),

  spinner: {
    margin: '2.25rem auto',
  },

  search: {
    width: '100%',
    margin: '2rem 0',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    form: {
      maxWidth: '25rem',
    },
  },

  buttonWrapper: {
    justifyContent: 'center',
    maxWidth: '100%',
    display: 'flex',
    flexDirection: 'row',

    '& > button': {
      marginRight: '2rem',

      '&:last-child': {
        marginRight: 0,
      },
    },
  },
};
